export default {
  LIGNE_PRINCIPALE: "LIGNE_PRINCIPALE",
  LIGNE_SECONDAIRE: "LIGNE_SECONDAIRE",
  ANALYSEUR: "ANALYSEUR",
  VITESSE: "VITESSE",
};
